export class GetSupportedRegionsResponse {
    regions?: string[];
}